import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_ALIGN,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
} from '@gcloud-npm/next12.components.text-info';
import Picture from '@gcloud-npm/next12.components.picture';
import { SendSondaComponentNotShown, GetButton } from '@/utils/functions';
import { useDispatch } from 'react-redux';
import Price, {
  FONT_TYPE,
  PRICE_COLOR,
  PRICE_DECORATION,
  PRICE_SIZE,
} from '@components/Price';
import styles from './styles';

const ModuloPlan = (props) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!props) {
      const componentName = 'ModuloPlan';
      SendSondaComponentNotShown(componentName, dispatch);
      return null;
    }
  }, []);

  const {
    imgPlan,
    altImage,
    cobertura,
    priceTachado,
    price,
    priceUnity,
    title,
    infoButton,
  } = props;

  return (
    <>
      <div className="moduloPlan container">
        <Picture
          sources={[{ src: imgPlan }]}
          alt={altImage}
          className="imgPlan"
        />
        <TextInfo
          text={cobertura}
          kind={TEXT_INFO_KIND.SPAN}
          align={TEXT_INFO_ALIGN.CENTER}
          color={TEXT_INFO_COLOR.GREY_6}
          size={TEXT_INFO_SIZE.TITLE7}
          fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
          className="cobertura"
        />
        <TextInfo
          text={title}
          kind={TEXT_INFO_KIND.HEADING}
          level={TEXT_INFO_HEADING_LEVEL.H2}
          align={TEXT_INFO_ALIGN.CENTER}
          color={TEXT_INFO_COLOR.GREY_6}
          size={TEXT_INFO_SIZE.TITLE2}
          fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
          className="title"
        />
        <div className="containerPrices">
          <Price
            amount={priceTachado}
            decoration={PRICE_DECORATION.LINE_THROUGH}
            size={PRICE_SIZE.EMP_30}
            color={PRICE_COLOR.GREY_4}
            withSpace={false}
            unity={priceUnity || '€'}
          />
          <Price
            amount={price < 0 ? 0 : price}
            decoration={PRICE_DECORATION.NONE}
            size={PRICE_SIZE.EMP_24}
            unity={priceUnity || '€/mes'}
            withSpace={false}
            color={PRICE_COLOR.BLUE_DARK}
            fontType={FONT_TYPE.BOLD}
            ty
          />
        </div>
        {GetButton(infoButton, infoButton.customClickEvent, {
          componentName: 'ModuloFeatureISRSalud',
          componentVariation: 'all',
          componentContent: infoButton.btnText,
        })}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ModuloPlan;

ModuloPlan.propTypes = {
  title: PropTypes.string,
  imgPlan: PropTypes.string,
  cobertura: PropTypes.string,
  priceTachado: PropTypes.number,
  price: PropTypes.number,
  priceUnity: PropTypes.string,
  infoButton: PropTypes.object,
};
ModuloPlan.defaultProps = {
  title: '',
  imgPlan: '',
  cobertura: '',
  priceTachado: 0,
  price: 0,
  priceUnity: '€',
  infoButton: {},
};
